var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1844_26822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8004 3.37512L13.5754 0.900085C13.5004 0.825085 13.3504 0.825195 13.2754 0.825195C12.9754 0.825195 12.7504 1.05016 12.7504 1.35016V3.15009C12.7504 3.15009 7.57539 3.15005 7.27539 8.55005C7.27539 8.85005 7.50039 9.15009 7.80039 9.15009C8.02539 9.15009 8.1754 9.00016 8.3254 8.85016C8.7004 8.02516 9.8254 6.00012 12.8254 6.00012V7.80005C12.8254 8.10005 13.0504 8.3252 13.3504 8.3252C13.5004 8.3252 13.5754 8.25005 13.6504 8.17505L16.9504 5.47516C17.2504 5.25016 17.4004 4.8752 17.4004 4.5752C17.2504 3.9002 17.1004 3.60012 16.8004 3.37512Z",
    stroke: "#58A291",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2.25H3.75C2.1 2.25 0.75 3.6 0.75 5.25V14.25C0.75 15.9 2.1 17.25 3.75 17.25H12.75C14.4 17.25 15.75 15.9 15.75 14.25V10.5",
    stroke: "#B8B8B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1844_26822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.85f5fa1c0c7726687be69ccdec063722.svg";
export { ForwardRef as ReactComponent };